import router from '@/router'
import { Modal, message } from 'ant-design-vue'
import storage from '@/utils/js/storage'
export default {
  state: {
    userInfo: storage.get('userInfo'),
    //授权菜单集合
    authMenuList: storage.get('authMenuList'),
  },
  mutations: {
  },
  actions:{
    /** 登录 */
    async login({state}, {token, userInfo, authMenuList}){
      localStorage.setItem("token", token)
      //用户信息
      localStorage.setItem("userInfo", JSON.stringify(userInfo))
      state.userInfo = userInfo
      //授权菜单
      if(!authMenuList) authMenuList = []
      localStorage.setItem("authMenuList", JSON.stringify(authMenuList))
      state.authMenuList = authMenuList
      message.success("登录成功！")
      router.push({name: 'INDEX'})
    },
    /** 退出登录 */
    logout(){
      Modal.confirm({
        title: "确认退出登录？",
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          this.dispatch("logoutHandler")
          message.success("退出登录成功！")
        }
      })
    },
    /** 退出登录处理 */
    logoutHandler({state}){
      localStorage.removeItem("token")
      localStorage.removeItem("userInfo")
      state.userInfo = null
      router.push({name: 'LOGIN'})
    }
  },
  getters:{
    /** 是否登录 */
    isLogin (state) {
      return state.userInfo != null;
    },
    userInfo(state){
      return state.userInfo || {}
    },
    getAuthMenuList(state){
      return state.authMenuList || []
    }
  },
}